import { render, staticRenderFns } from "./BookingInformation.vue?vue&type=template&id=1b110ec1&"
import script from "./BookingInformation.vue?vue&type=script&lang=ts&"
export * from "./BookingInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports